import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DSComponents, DesignSystemHelperService } from '@frontend/promo-utils';
import { DsCard } from '@frontend/ui/card';

import { ResultsPlayerInfo } from '../../models/results/results-player-info';

@Component({
    selector: 'tp-results-info',
    templateUrl: './results-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DsCard, NgClass],
})
export class ResultsInfoComponent {
    @Input() resultsPlayerInfo: ResultsPlayerInfo;
    @Input() isSinglePrize: boolean = false;

    dsComponents: DSComponents;

    constructor(private designSystemHelperService: DesignSystemHelperService) {
        this.dsComponents = this.designSystemHelperService.getDsComponentsList();
    }
}
